// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"noodle"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 12V11H3V12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16 4L17 4M17 4H20M17 4V10M20 4H21M20 4V10M4 10C4 7.23858 6.23858 5 9 5C11.7614 5 14 7.23858 14 10V11H4L4 10ZM7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10V11H7V10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 12V11H3V12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-noodle')
export default class NoodleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'noodle',
    }
  }
}
